var pym = require("./lib/pym");
require("./lib/webfonts");
var topojson = require("topojson/dist/topojson.min");
var us = require("./ny_covid_zip.json");
var ch = require("./cypress_hills_outline.json");

// build our custom D3 object
var d3 = {
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-geo/dist/d3-geo.min"),
  ...require("d3-fetch/dist/d3-fetch.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min"),
};

// var d3 = require("d3/dist/d3.min");
var { COLORS, classify } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var tooltip;

// Global vars
var pymChild = null;

// Initialize the graphic.
var onWindowLoaded = function() {

    var geodata = topojson.feature(us, us.objects["ny_covid_zip"]).features;
    var ch_geodata = topojson.feature(ch, ch.objects["cypress_hills_outline"]).features;

    render(geodata, ch_geodata);
    window.addEventListener("resize", function() { render(geodata, ch_geodata) });
    tooltip = document.getElementById("tooltip");

    pym.then(function(child) {
      pymChild = child;
      pymChild.sendHeight();
    });

};

// Render the graphic(s). Called by pym with the container width.
var render = function(geodata, ch_geodata) {

  // Render the map!
  var container = "#state-grid-map";
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  var table = document.getElementById("table-graphic");
  var blockContainer = document.getElementById("blocks-container");

  renderStateGridMap({
    container,
    width,
    data: geodata,
    ch_data: ch_geodata,
    geodata
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Render a state grid map.
var renderStateGridMap = function(config) {

  const dataGroup = d3.group(config.data, d => d.state_name, d => d.status);

  var values = config.data.map(d => +d.properties.COVID_DEATH_RATE);
  var min = d3.min(values);
  var max = d3.max(values);

  var colorScale = d3
      .scaleLinear()
      .domain([min, max/2, max])
      .range(["#fff", COLORS.yellow2, COLORS.yellow1]);

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 4 : 12;

  var margins = { top: 0, right: 6, bottom: 6, left: 6 };

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top - margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // D3 Projection
  var projection = d3.geoAlbersUsa()
    .fitExtent([[margins.left, margins.top], [chartWidth, chartHeight]], topojson.feature(us, us.objects["ny_covid_zip"]));

  // Define path generator
  var path = d3.geoPath().projection(projection);

  var chartWrapper = containerElement
   .append("div")
   .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
   .append("svg")
   .attr("width", chartWidth + margins.left + margins.right)
   .attr("height", chartHeight + margins.top + margins.bottom)
   .append("g")
   .attr("transform", `translate(${margins.left},${margins.top})`);

  var barWidth = 30;

  // var colorLegend = chartElement
  //  .append("g")
  //  .attr("transform", isMobile.matches ? "translate("+ (chartWidth*0.5 - (colorScale.domain().length*barWidth)/2) +","+(-margins.top)+")" : "translate("+ (chartWidth*0.65) +","+(-margins.top)+")");

 // colorLegend.selectAll("rect")
 //  .data(colorScale.domain())
 //  .enter()
 //  .append("rect")
 //  .attr("width", barWidth)
 //  .attr("height", 8)
 //  .attr("x", (d,i) => barWidth*i)
 //  .attr("y",0)
 //  .style("fill", d => colorScale(d));

// var keyLabels = colorScale.domain();
// var theRemovedElement = keyLabels.shift();

// colorLegend.selectAll("text")
//   .data(keyLabels)
//   .enter()
//   .append("text")
//   .attr("class","key")
//   .attr("x", (d,i) => barWidth*(i+1))
//   .attr("y", 26)
//   .style("text-anchor","middle")
//   .text(d => Math.round(d*100) + "%");
//
// colorLegend.selectAll("line")
//   .data(keyLabels)
//   .enter()
//   .append("line")
//   .attr("x1", (d,i) => barWidth*(i+1))
//   .attr("x2", (d,i) => barWidth*(i+1))
//   .attr("y1", 0)
//   .attr("y2", 14)
//   .style("stroke", COLORS.gray1)
//   .style("stroke-width", 1);

 var lookup = new Map();
 dataGroup.forEach(function(value, key) {
   lookup.set(key, value.size);
 });

  var mapGroup = chartElement
   .append("g")
   .attr("class", "map");

  var states = mapGroup
   .selectAll("path")
   .data(config.data)
   .enter()
   .append("path")
   .attr("class", d => "zip-" + d.properties.ZCTA5CE10 + " map")
   .attr("fill", d => colorScale(+d.properties.COVID_DEATH_RATE))
   .attr("stroke-weight", 0)
   .attr("d", path);

 var chGroup = mapGroup
  .selectAll(".ch-path")
  .data(config.ch_data)
  .enter()
  .append("path")
  .attr("class", d => "ch-path")
  .attr("fill", "none")
  .attr("stroke", COLORS.gray1)
  .attr("stroke-weight", 1)
  .attr("d", path);

  states.on("mouseenter", function(d) {
    if (lookup.get(d.properties.name)) {
      states.attr("stroke-width", 0);
      var highlight = d3.select(this);
      highlight.raise();
      chGroup.raise();
      highlight.attr("stroke", COLORS.gray1);
      highlight.attr("stroke-width", 2);
      tooltip.style.visibility = "visible";
    }
  });

  states.on("mousemove", function(d){
    if (lookup.get(d.properties.name)) {
      var x = event.clientX;
      var y = event.clientY;
      var tooltipHeight = tooltip.offsetHeight;
      tooltip.style.left = x < config.width/2 ? x + 10  + "px": x - (tooltip.offsetWidth + 10) + "px";
      tooltip.style.top = y - tooltipHeight + "px";
      tooltip.innerHTML = `In zip code ${d.properties.ZCTA5CE10}, 1 of every ${Math.round(100000/d.properties.covid_death_rate_num)} people died.`;
    }
  });

  states.on("mouseout", function(d) {
    var highlight = d3.select(this);
    highlight.attr("stroke-width", 0);
    tooltip.style.visibility = "hidden";
  });

};



// Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
